import type { PropsWithChildren } from "react";
import { useLocation } from "react-router-dom";
import { landingByLocale } from "../content";
import type { Locale, RouteKind } from "../content/types";
import { SiteFooter } from "./SiteFooter";
import { SiteHeader } from "./SiteHeader";

type SiteLayoutProps = PropsWithChildren<{
  locale: Locale;
  page: RouteKind;
}>;

export function SiteLayout({ children, locale, page }: SiteLayoutProps) {
  const { search } = useLocation();
  const landing = landingByLocale[locale];
  // ?embed=1 去掉页头页脚，供 App 内嵌打开隐私政策/用户协议时使用
  const contentOnly = new URLSearchParams(search).get("embed") === "1";

  return (
    <div className={contentOnly ? "site-shell site-shell-embed" : "site-shell"}>
      {contentOnly ? null : <SiteHeader content={landing} locale={locale} page={page} />}
      <main>
        {contentOnly ? (
          <div className="embed-brand" aria-label="Moodshot">
            <img src="/images/moodshot-icon.svg" alt="" width="32" height="32" />
            <span>Moodshot</span>
          </div>
        ) : null}
        {children}
      </main>
      {contentOnly ? null : <SiteFooter content={landing.footer} nav={landing.nav} locale={locale} />}
    </div>
  );
}
